module.exports = __webpack_public_path__ + "static/home-coaching-feff6c9e60d5b4c938e64c88a132ea4c.jpg";